
export default {
    CURRENT_ACCOUNT: "CURRENT_ACCOUNT",
    LINKED_ACCOUNT: "LINKED_ACCOUNT",
}